import React, {useEffect, useRef, useState} from "react"
import {useParams} from "react-router";
import Producent from "../../../model/producent";
import * as ProducentService from "../../../service/static/producentServiceStatic"

import './showProducent.scss'
import BackToStart from "../../components/BackToStart";

const ShowProducent = () => {
    let producentId = useParams().id

    let fetchingProducent = useRef<boolean>(false)
    let fetchedProducent  = useRef<boolean>(false)

    const [producent, setProducent] = useState<Producent | undefined>(undefined)

    useEffect(() => {
        const fetchProducent = async () => {
            fetchingProducent.current = true

            // @ts-ignore
            const fromDb = await ProducentService.getById(producentId)
            fetchedProducent.current = true
            fetchingProducent.current = false

            setProducent(fromDb)
        }

        if (!fetchingProducent.current && !fetchedProducent.current)
            fetchProducent()
    })

    return (
        <div>
            <div className="container-fluid">
                <div className="row">
                    <h1 className="col-md-10">{producent?.namn}</h1>
                    <div className="col-md-2">
                        <BackToStart />
                    </div>
                </div>
                <div className="row table-row">
                    <div className="col-md-3">Aktörssträng</div>
                    <div className="col-md-9">{producent?.aktor}</div>
                </div>
                <div className="row table-row">
                    <div className="col-md-3">URL till tjänst</div>
                    <div className="col-md-9">{producent?.apiUrl}</div>
                </div>
                <div className="row table-row">
                    <div className="col-md-3">URL till dokumentation</div>
                    <div className="col-md-9">{producent?.dokUrl}</div>
                </div>
                <div className="row table-row">
                    <div className="col-md-3">Format</div>
                    <div className="col-md-9">{producent?.format}</div>
                </div>
                <div className="row table-row">
                    <div className="col-md-3">Licens</div>
                    <div className="col-md-9">{producent?.licens}</div>
                </div>
                <div className="row table-row">
                    <div className="col-md-3">Version av Mina ärendens standard</div>
                    <div className="col-md-9">{producent?.version}</div>
                </div>
                <div className="row table-row">
                    <div className="col-md-3">Senast uppdaterad</div>
                    <div className="col-md-9">{producent?.updatedAt?.toLocaleDateString("sv-SW")}</div>
                </div>

            </div>
        </div>
    )
}

export default ShowProducent